import React from 'react';

export const UserContext = React.createContext({});

const ModalContext = React.createContext({ data: {} });
export const ModalConsumer = ModalContext.Consumer;
export const ModalProvider = ModalContext.Provider;